import React from 'react';
import { ExpandableSection } from 'AWS-UI-Components-React';
import { ViewByTimeFrame } from './view_by_timeframe';
import { aggregateByTimeframe } from './utils';

/**
 * Given a map of test results by channel,
 * renders the test results putting each channel
 * in an expandable section which display the
 * corresponding test results upon expansion.
 */
export class ViewByChannel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getHeader = (channel) => {
    return channel && channel.toLowerCase() !== 'none' ? channel.toUpperCase() : 'Not Channel Specific';
  };

  render() {
    const { title, chart, testResultsByChannel } = this.props;

    return (
      <div>
        <h2>{title}</h2>
        <div>{chart ? chart : ''}</div>
        {Object.keys(testResultsByChannel).map((channel) => {
          const byTimeFrame = aggregateByTimeframe(testResultsByChannel[channel]);
          return (
            <ExpandableSection
              key={'TestResultsByChannelExpandableSection' + channel}
              header={this.getHeader(channel)}
              variant="borderless"
            >
              <div className="awsui-util-container">
                <ViewByTimeFrame
                  key={'TestResultsByChannelTimeFrame' + channel}
                  testResultsByTimeFrame={byTimeFrame}
                  title={''}
                  loadValidationTestResults={this.props.loadValidationTestResults}
                />
              </div>
            </ExpandableSection>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/validation_test_results/view_by_channel.jsx